module.exports = __webpack_public_path__ + "img/NL118.c47c1ca1.png";